import { LoadablePaint } from '@confluence/loadable';

export const DetailsSummaryExtensionHandler = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-DetailsSummaryExtensionHandler" */ '../src/DetailsSummaryExtensionHandler.tsx'
			)
		).DetailsSummaryExtensionHandler,
});
